import { Flex, Group, Stack } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useProcessAnalysisStore } from '../../../../../store/process-analysis-store/process-analysis-store';
import { inkLight } from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';
import { useWorkUnitsData } from '../../../hooks/work-units';
import { SideSectionWorkUnitsItem } from './side-section-work-units-item';
import { SideSectionWorkUnitsSort } from './side-section-work-units-sort';
import { formatWorkUnitsCount, sortWorkUnits } from './side-section-work-units.helpers';
import { WorkUnitsSortOption } from './side-section.type';

export const SideSectionWorkUnits = () => {
  const { t } = useTranslation();
  const selectedDataPoint = useProcessAnalysisStore((state) => state.selectedDataPoint);
  const { data: workUnits, isFetching } = useWorkUnitsData();
  const [sortBy, setSortBy] = useState<WorkUnitsSortOption>(WorkUnitsSortOption.CreatedDate);

  if (!selectedDataPoint || isFetching) {
    return null;
  }

  const header = (
    <Group justify="space-between">
      <Text size="small" weight="medium">
        {selectedDataPoint.date}
      </Text>
      {workUnits && workUnits.length > 0 && (
        <Text size="small" weight="medium">
          {formatWorkUnitsCount(workUnits.length, t)}
        </Text>
      )}
    </Group>
  );

  if (!workUnits || workUnits.length === 0) {
    return (
      <Stack>
        {header}
        <Flex
          style={{
            padding: '0px 24px',
          }}
          align="center"
        >
          <Text
            size="small"
            color={inkLight}
            style={{
              lineHeight: 1.5,
              textAlign: 'center',
              maxWidth: '280px',
            }}
          >
            {t('process_analysis.work_units.no_work_units_found', {
              work_units: t('common.work_units').toLowerCase(),
            })}
          </Text>
        </Flex>
      </Stack>
    );
  }

  const sortedWorkUnits = sortWorkUnits(workUnits, sortBy);

  return (
    <Stack>
      {header}
      <SideSectionWorkUnitsSort sortBy={sortBy} onSortChange={setSortBy} />
      <Stack gap={8}>
        {sortedWorkUnits.map((task) => (
          <SideSectionWorkUnitsItem key={task.id} task={task} />
        ))}
      </Stack>
    </Stack>
  );
};
